import { render, staticRenderFns } from "./sku-list.vue?vue&type=template&id=61a358c7&scoped=true"
import script from "./sku-list.vue?vue&type=script&lang=ts"
export * from "./sku-list.vue?vue&type=script&lang=ts"
import style0 from "./sku-list.vue?vue&type=style&index=0&id=61a358c7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a358c7",
  null
  
)

export default component.exports